<template>
  <div>
    <h3 class="font-weight-bold secondary--text mb-4">{{ $t('label.pointRedemption') }}</h3>
    <v-card class="d-flex" style="flex: 1">
      <div
        class="rounded-tr-0 rounded-bl primary lighten-1 text-center"
        :class="{
          'pa-6': $vuetify.breakpoint.smAndUp,
          'pa-2': !$vuetify.breakpoint.smAndUp
        }"
      >
        <img src="@/assets/coin-2x.png" class="mx-auto mb-1" />
        <span class="white--text text-center point-label">{{ point.point_available }} {{ $t('label.points') }}</span>
      </div>
      <div
        class="d-flex flex-column"
        :class="{
          'pa-6 px-4': $vuetify.breakpoint.smAndUp,
          'pa-4 px-2': !$vuetify.breakpoint.smAndUp
        }"
        style="flex: 3"
      >
        <span
          class="text-h6 primary--text text--lighten-1"
          style="line-height: 1.3rem"
          :class="{
            'px-6': $vuetify.breakpoint.smAndUp,
            'px-4': !$vuetify.breakpoint.smAndUp
          }"
        >
          {{ $t('label.points') }}
        </span>
        <v-text-field
          v-model="coinsToUse"
          placeholder="0"
          hide-details
          dense
          rounded
          color="primary lighten-1"
          class="coins-field mb-auto shrink primary--input font-weight-medium text-h5 mt-0"
        ></v-text-field>
        <div
          class="d-flex flex-row align-center justify-space-between border-bottom"
          :class="{
            'pa-2 pt-0 px-6': $vuetify.breakpoint.smAndUp,
            'pb-2 px-4 pr-0': !$vuetify.breakpoint.smAndUp
          }"
        >
          <div class="text-h6">{{ pointConversion }}</div>
          <app-button invert class="lighten-1" :label="$t('label.pointRedemptionApply')" @click="applyRedeem" />
        </div>
      </div>
    </v-card>
    <p class="text-subtitle-1 font-weight-medium mt-3" style="line-height: 0.8rem; font-size: 0.5rem">{{ point.point_redemption_rate.replace('points', $t('label.points')) }}</p>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { uiHelper } from '@/utils'

export default {
  props: ['point', 'currency'],

  data() {
    return {
      coinsToUse: ''
    }
  },
  computed: {
    pointConversion() {
      let conversionText = uiHelper.priceFormatter(Number(this.coinsToUse) / Number(this.point.point_redemption_conversion_rate))
      return `≈ ${this.currency} ${conversionText}`
    }
  },
  created() {
    this.redeemPoint({ points: 0 })
  },
  methods: {
    ...mapActions('order', ['redeemPoint']),
    applyRedeem() {
      this.redeemPoint({ points: this.coinsToUse })
        .then()
        .catch((err) => {
          if (err.error_message === 'Points to redeem is not valid!') {
            this.$toast.error(this.$t('error.pointsToRedeemInvalid'))
          } else this.$toast.error(err.error_message)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .coins-field .v-input__control .v-input__slot:before {
  border: none;
}
::v-deep .coins-field .v-input:focus {
  border: none;
}

.point-label {
  white-space: nowrap;
}

.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);
}
</style>
